export default "__VITE_ASSET__DYnglgqu__"